module.exports = __webpack_public_path__ + "static/media/ramin.332976fe.jpg";